import { OrganizationAdminPermissionName } from ':src/graphql/enums';
import useViewer from './useViewer';

export default function usePermissions() {
  const { viewer } = useViewer();
  return {
    hasPermission: (permissionName: OrganizationAdminPermissionName, programId?: string) => {
      const permissionsIncludesName = viewer.permissions?.permissionNames.includes(permissionName);
      if (!permissionsIncludesName) {
        return false;
      }
      return (
        programId == null ||
        viewer.permissions?.programIds == null ||
        viewer.permissions.programIds.includes(programId)
      );
    },
  };
}
